var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"color-gray no-wrap"},[_vm._v(_vm._s(_vm.marketPremiumInfo.getLabel()))]),_c('div',[_c('data',[_vm._v(_vm._s(_vm.marketPremiumInfo.getValueFormatted()))]),_c('span',[_c('b',[_vm._v(" "+_vm._s(_vm.marketPremiumInfo.getUnit()))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }